import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader, Table } from "reactstrap";
import Skeleton from "react-loading-skeleton";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useLoader } from "../../_helper/LoaderContext";
import { usePharmacy } from "../../_helper/PharmacyProvider";
import { getStocksAPI } from "../PharmacyManageStocks/ManageStocksService";

const fetchExpired = () =>
  new Promise((resolve) => {
    setTimeout(() => {
      resolve([
        { name: "Amoxicillin", batch: "E123" },
        { name: "Cetirizine", batch: "E456" },
        { name: "Cetirizine", batch: "E456" },
        { name: "Cetirizine", batch: "E456" },
        { name: "Cetirizine", batch: "E456" },
        { name: "Cetirizine", batch: "E456" },
        { name: "Cetirizine", batch: "E456" },
        { name: "Cetirizine", batch: "E456" },
        { name: "Cetirizine", batch: "E456" },
        { name: "Cetirizine", batch: "E456" },
      ]);
    }, 1000);
  });

const ExpiredProducts = () => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const { loading, setLoading } = useLoader();
  const { pharmacyPOS } = usePharmacy();
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [skeletonLoading, setSkeletonLoading] = useState(false);
  const history = useNavigate();

  useEffect(() => {
    getStocks();
    // fetchExpired().then((res) => {
    //   setData(res);
    //   setLoading(false);
    // });
  }, []);

  const getStocks = async () => {
    const body = {
      clinicId: pharmacyPOS?.hospital_id,
      isExpired: true,
      page: page,
      limit: size,
      search: ''
    };
    try {
      setLoading(true);
      setSkeletonLoading(true);
      const response = await getStocksAPI(body);
      setData(response.data.data.stocks || []);
      // const totalCount = response.data.data.total || 0;
      // setTotalItems(Math.ceil(totalCount / size));
    } catch (error) {
      console.error("Error fetching sales history:", error);
    } finally {
      setLoading(false);
      setSkeletonLoading(false);
    }
  };

  const gotoList = () => {
    history(`${process.env.PUBLIC_URL}/expired-stock`);
  }

  return (
    <Card className="h-100">
      <CardHeader className="d-flex justify-content-between align-items-center">
        <h6 className="mb-0">{t("Items Expired")}</h6>
        <button
          type="button"
          onClick={gotoList}
          className="btn btn-link p-0 text-primary small text-underline"
          style={{ textDecoration: "none" }}
        >
          {t("View All")}
        </button>
      </CardHeader>
      <CardBody>
        {loading ? (
          <Skeleton count={5} height={30} />
        ) : data.length === 0 ? (
          <p className="text-center text-muted">{t("No expired products found")}</p>
        ) : (
          <div className="tw-h-[250px] tw-overflow-y-scroll">
            <Table size="sm" striped bordered responsive>
              <thead>
                <tr>
                  <th>{t("Brand Name")}</th>
                  <th>{t("Batch No")}</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, idx) => (
                  <tr key={idx}>
                    <td>
                      <span
                        className="d-inline-block text-truncate"
                        style={{ maxWidth: "100%", whiteSpace: "nowrap" }}
                        title={item.brandName}
                      >
                        {item.brandName}
                      </span>
                    </td>
                    <td>{item.stockData[0].batchNumber}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default ExpiredProducts;
